import { useEffect } from 'react'
import { useAuth } from '../auth/AuthContext.js'

// TSupport — Trustline's shared support/ticket tool (support.trustline.solutions).
// Its widget.js reads window.TrustlineSupportConfig and adds its own floating
// "Support" button + panel to the page; nothing else is needed here.
// Shown only inside a tenant login (AppShell) — the /admin platform screen never loads it.
const WIDGET_SRC = 'https://support.trustline.solutions/widget.js'
const WA_NUMBER = '917540002382' // Trustline support WhatsApp (country code + number)
const SCRIPT_ID = 'trustline-support-widget'

export function SupportWidget() {
  const { user } = useAuth()

  useEffect(() => {
    if (!user || !user.tenant_id) return
    ;(window as unknown as { TrustlineSupportConfig: unknown }).TrustlineSupportConfig = {
      product: 'TFleet',
      tenant_id: user.tenant_id,
      tenant_name: user.tenant_name ?? '',
      contact_name: user.name ?? '',
      contact_email: user.email ?? '',
      contact_mobile: user.phone ?? '',
      wa_number: WA_NUMBER,
    }
    if (document.getElementById(SCRIPT_ID)) return // already injected
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.src = WIDGET_SRC
    script.async = true
    document.body.appendChild(script)
  }, [user])

  return null
}
